import { inject } from '@angular/core';
import { from, map, Observable, of } from 'rxjs';
import { Channel, FormatMessageResponse } from 'stream-chat';
import { STREAM_CHANNEL_TOKEN, StreamChannelProvider } from '../../../../infrastructure/tokens';

export class MarkUnreadCommandHandler {
  private readonly channelProvider: StreamChannelProvider = inject(STREAM_CHANNEL_TOKEN);

  markAsUnread(): Observable<void> {
    const channel: Channel | undefined = this.channelProvider.getActiveChannel();
    const lastMessageId: string | undefined = this.resolveLastMessageId(channel);

    if (!lastMessageId) return of(void 0);

    return from(this.channelProvider.markActiveChannelUnread(lastMessageId)).pipe(map(() => void 0));
  }

  private resolveLastMessageId(channel: Channel | undefined): string | undefined {
    const messages: FormatMessageResponse[] | undefined = channel?.state?.messages;
    if (!messages || messages.length === 0) return undefined;
    return messages[messages.length - 1]?.id;
  }
}
